import React, { Component } from 'react';

//Booststrap
import {Button} from 'reactstrap';

import './backing.scss';

class Backing extends Component {
  constructor(props){
    super(props);
    this.state = {
      backingVis: false
    }
  }
  Visible(){
    this.setState(prevState =>{
      return{backingVis: !this.state.backingVis}
    });
  }
  Cotizar(){
    //console.log("Datos de prueba");
  }
  render() {
    return (
      <div className={"Backing"}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178 178" onClick={()=>{this.Visible()}}>
          <defs>
          </defs>
          <title>Backing</title>
            <g id="Capa_2" data-name="Capa 2">
              <g id="Capa_1-2" data-name="Capa 1">
                <g className="cls-1">
                <circle className="cls-2" cx="89" cy="89" r="87"/>
                <path className="cls-3" d="M33.05,28.38l-2.69,0,0-4.9,118,1,0,4.9-2.69,0-1.1,99.15s2.93.51,2.9,4.18l-.15,17.87s-7.16,6.79-55.89,7.35c0,0-62,1.67-62.15-5.19l.18-20.32a4.21,4.21,0,0,1,2.71-1.94Z"/>
                </g>
              </g>
            </g>
        </svg>
        <div className={(this.state.backingVis? 'BackingVis': 'Backinghidd ')}>
          <h4>Backing</h4>
          <h6><strong>Backing</strong> publicitarios completamente portables y adaptables a cualquier espacio.</h6>
          <Button onClick={this.Cotizar()} >Cotizar</Button>
        </div>
        <div className={"Backingflexdirection"}>
          <Button color="info" className={"btnOption"} onClick={()=> {this.Visible()}} >
            <div className="IconNext">
              <i className="fas fa-angle-down"  ></i>
            </div>
          </Button>
        </div>
      </div>
        )
    }
}

export default Backing;



// WEBPACK FOOTER //
// ./src/Components/Section-Principal/backing/backing.jsx